import React, { useContext } from 'react';

import { StoreContext } from '../../context/store-context';
import CartItemRecommend from './CartItem/CartItemRecommend';

const CartRecommendedProducts = () => {
	const { cart, productsRecommend } = useContext(StoreContext);
	const handleProducts = cart?.lines?.edges.map(
		({ node }) => node.merchandise.product.handle
	);

	const filteredProducts = productsRecommend?.filter(
		(product) => !handleProducts?.includes(product.handle)
	);
	const productsSlice = filteredProducts?.slice(0, 2);

	return (
		<div id="cart-recommended-products" className='recommend-products hidden-ab-v2'>
			<h3>Our top recommendations</h3>

			{productsSlice?.map((product) => (
				<CartItemRecommend key={product.handle} product={product} />
			))}
		</div>
	);
};

export default CartRecommendedProducts;
